// Dependencias
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '../store';

import { LOCALSTORAGE_KEY_LOGIN } from '../lib/Authentication';
import { canAccessClientes, canAccessTemplates, canAccessUsuarios, canAccessSupervisao } from '../lib/Permissions';
import { isTokenExpired, resetAllLoginData } from '../lib/Authentication/src/VerifyTokenJWT';

// vue router
Vue.use(VueRouter);

// Deinição das rotas
const routes = [
  {
    path: '/',
    name: 'intro',
    component: Home,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Home',
      subtitle: 'Atalhos rápidos',
    },
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Home',
      subtitle: 'Atalhos rápidos',
    },
  },
  {
    path: '/autenticacao',
    name: 'authentication',
    component: () => import('../views/Autenticacao.vue'),
    meta: {
      requiresAuth: false,
      showSidebar: false,
    },
  },
  {
    path: '/convite/:token',
    name: 'onboardingConvite',
    component: () => import('../views/OnboardingConvite.vue'),
    meta: {
      requiresAuth: false,
      showSidebar: false,
    },
  },
  {
    path: '/templates',
    name: 'templates',
    component: () => import('../views/Templates.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Templates',
      subtitle: 'Templates pré definidos para geração de configurações de cliente',
      requiresPermission: 'templates',
    },
  },
  {
    path: '/clientes',
    name: 'customers',
    component: () => import('../views/Clientes.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Clientes',
      subtitle: 'Clientes que utilizam os serviços do Configurador',
      requiresPermission: 'clientes',
    },
  },
  {
    path: '/configuracoes',
    name: 'settings',
    component: () => import('../views/configuracoes/Listar.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Configurações',
      subtitle: 'Configurações de clientes para o Configurador',
    },
  },
  {
    path: '/configuracoes/editar/:IDENTIFICACAODOCLIENTE/:NOMEDACONFIGURACAO',
    name: 'configuracaoEditar',
    component: () => import('../views/configuracoes/Editar.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Editar Configuração',
      subtitle: 'Edite os campos da configuração',
    },
  },
  {
    path: '/configuracoes/historico/:id',
    name: 'configuracaoHistorico',
    component: () => import('../views/configuracoes/Historico.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Histórico de Alterações',
      subtitle: 'Histórico de alterações desta configuração',
    },
  },
  {
    path: '/templates/reorganizar/:nomeTemplate',
    name: 'templateReorganizar',
    component: () => import('../views/templates/ReorganizarTemplate.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Reorganizar Template',
      subtitle: 'Reorganize entradas e grupos do template',
      requiresPermission: 'templates',
    },
  },
  {
    path: '/templates/editar/:nomeTemplate',
    name: 'templateEditar',
    component: () => import('../views/templates/EditarTemplate.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Editar Template',
      subtitle: 'Edite as entradas e configurações do template',
      requiresPermission: 'templates',
    },
  },
  {
    path: '/templates/:nomeTemplate/:chaveEntrada',
    name: 'templateEditarEntradaEmMassa',
    component: () => import('../views/templates/EditarEntradaEmMassa.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Editar Entrada em Massa',
      subtitle: 'Edite uma entrada específica em vários clientes simultaneamente',
      requiresPermission: 'templates',
    },
  },
  {
    path: '/upload',
    name: 'uploadFile',
    component: () => import('../views/Upload.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Upload de arquivos',
      subtitle: 'Área para fazer upload de arquivos',
    },
  },
  {
    path: '/dump',
    name: 'dump',
    component: () => import('../views/Dump.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Dump de banco de dados',
      subtitle: 'Área para fazer o dump de um banco de dados',
    },
  },
  {
    path: '/dumps/historico',
    name: 'dumpsHistorico',
    component: () => import('../views/DumpsHistorico.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Histórico de Dumps',
      subtitle: 'Visualize o histórico completo de operações de dump',
    },
  },
  {
    path: '/dump/:id',
    name: 'dumpView',
    component: () => import('../views/DumpView.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Dump de banco de dados',
      subtitle: 'Área para fazer o dump de um banco de dados',
    },
  },
  {
    path: '/usuarios',
    name: 'usuario',
    component: () => import('../views/Usuarios.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Gestão de usuário',
      subtitle: 'Área para fazer a gestão de usuários do Configurador',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/usuarios/novo',
    name: 'usuarioNovo',
    component: () => import('../views/usuarios/Formulario.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Novo usuário',
      subtitle: 'Cadastro de usuário do Configurador',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/usuarios/:id/editar',
    name: 'usuarioEditar',
    component: () => import('../views/usuarios/Formulario.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Editar usuário',
      subtitle: 'Edição de usuário do Configurador',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/usuarios/:id',
    name: 'usuarioVisualizar',
    component: () => import('../views/usuarios/Formulario.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Visualizar usuário',
      subtitle: 'Consulta de usuário do Configurador',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/supervisao',
    name: 'supervisao',
    component: () => import('../views/Supervisao.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Supervisão',
      subtitle: 'Logs de atividade dos usuários supervisionados',
      requiresPermission: 'supervisao',
    },
  },
  {
    path: '/oauth/authorize',
    name: 'oauthAuthorize',
    component: () => import('../views/OAuthAuthorize.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: false,
      title: 'Autorizar aplicação',
    },
  },
  {
    path: '/oauth-apps',
    name: 'oauthApps',
    component: () => import('../views/OAuthApps.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Apps e Atalhos',
      subtitle: 'Gerenciamento de aplicações OAuth/OIDC',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/oauth-apps/integracao',
    name: 'oauthIntegracaoTutorial',
    component: () => import('../views/oauth/IntegracaoTutorial.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Tutorial integração OAuth',
      subtitle: 'Escolha o tipo do app e siga o passo a passo',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/oauth-apps/integracao/:tipo(public|hybrid|confidential)',
    name: 'oauthIntegracaoTutorialTipo',
    component: () => import('../views/oauth/IntegracaoTutorial.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Tutorial integração OAuth',
      subtitle: 'Passo a passo por tipo de aplicação',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/oauth-apps/novo',
    name: 'oauthAppNovo',
    component: () => import('../views/oauth/Formulario.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Nova aplicação OAuth',
      subtitle: 'Cadastro de integração OAuth/OIDC',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/oauth-apps/:id/editar',
    name: 'oauthAppEditar',
    component: () => import('../views/oauth/Formulario.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Editar aplicação OAuth',
      subtitle: 'Edição de integração OAuth/OIDC',
      requiresPermission: 'logins',
    },
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import('../components/SSOExample.vue'),
    meta: {
      requiresAuth: false,
      showSidebar: false,
    },
  },
  {
    path: '/access-denied',
    name: 'accessDenied',
    component: () => import('../views/AccessDenied.vue'),
    meta: {
      requiresAuth: false,
      showSidebar: false,
    },
  },
  {
    path: '/landing-pages',
    name: 'landingPages',
    component: () => import('../views/LandingPages.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Landing Pages',
      subtitle: 'Gestão de landing pages para campanhas e promoções',
    },
  },
  {
    path: '/limpeza',
    name: 'limpeza',
    component: () => import('../views/LimpezaBanco.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Limpeza de Banco',
      subtitle: 'Limpeza automatizada de banco de dados',
    },
  },
  {
    path: '/limpezas/historico',
    name: 'limpezasHistorico',
    component: () => import('../views/LimpezasHistorico.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Histórico de Limpezas',
      subtitle: 'Visualize o histórico de operações de limpeza',
    },
  },
  {
    path: '/limpeza/:id',
    name: 'limpezaView',
    component: () => import('../views/LimpezaView.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Limpeza de Banco',
      subtitle: 'Acompanhamento da execução da limpeza',
    },
  },
  {
    path: '/operacoes-criticas',
    name: 'operacoes-criticas',
    component: () => import('../views/OperacoesCriticas.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Operações Críticas',
      subtitle: 'Gerencie operações críticas de banco de dados',
      requiresPermission: 'autenticacao2FA.operacoes_criticas',
    },
  },
  {
    path: '/custosvariaveis',
    name: 'custosVariaveis',
    component: () => import('../views/CustosVariaveis.vue'),
    meta: {
      requiresAuth: true,
      showSidebar: true,
      title: 'Custos Variáveis',
      subtitle: 'Painel de custos variáveis',
    },
  },
  {
    path: '/design-system',
    name: 'designSystem',
    component: () => import('../views/DesignSystem.vue'),
    meta: {
      requiresAuth: false,
      showSidebar: false,
      title: 'Design system',
      subtitle: 'Tokens e componentes base do Configurador',
    },
  },
  {
    path: '/*',
    name: 'pageNotFound',
    component: () => import('../views/PageNotFound.vue'),
    meta: {
      requiresAuth: false,
      showSidebar: false,
    },
  },
];

// Criação do router
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Verificação pré rota
router.beforeEach(async (to, from, next) => {
  // Verificar se é a rota de acesso negado
  if (to.name === 'accessDenied') {
    next();
    return;
  }

  // Verificar IP antes de qualquer outra verificação
  try {
    // Emitir evento para mostrar loading
    if (router.app && router.app.$root) {
      router.app.$root.$emit('ip-check-start');
    }

    const IPChecker = (await import('../lib/IPChecker')).default;
    const isIPAllowed = await IPChecker.isIPAllowed();

    // Emitir evento para esconder loading
    if (router.app && router.app.$root) {
      console.log('Router: Emitindo evento ip-check-end (sucesso)');
      router.app.$root.$emit('ip-check-end');
    }

    if (!isIPAllowed) {
      next({ name: 'accessDenied' });
      return;
    }
  } catch (error) {
    console.error('Erro na verificação de IP:', error);

    if (router.app && router.app.$root) {
      router.app.$root.$emit('ip-check-end');
    }

    next({ name: 'accessDenied' });
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Requer autenticação
    const tokenJWT = localStorage.getItem('tokenJWT');
    const userData = localStorage.getItem('userData');
    const userDataParsed = userData ? JSON.parse(userData) : null;

    const user2FAAtivo = userDataParsed && userDataParsed.autenticacao2FA && userDataParsed.autenticacao2FA.configurado;

    if (isTokenExpired(tokenJWT) || !user2FAAtivo) {
      resetAllLoginData();
      if (to.name === 'oauthAuthorize') {
        const returnUrl = encodeURIComponent(to.fullPath);
        window.location.href = `/autenticacao?returnUrl=${returnUrl}`;
        return;
      }
      window.location.href = '/autenticacao?deslogado=true';
      return;
    } else {
      // Verificar permissões específicas
      if (to.meta.requiresPermission) {
        const userPermissions = store.getters['autenticacao/getUserPermissions'];

        // Se não temos permissões no store, permitir acesso (dados serão carregados após login)
        if (!userPermissions || Object.keys(userPermissions).length === 0) {
          next();
          return;
        }

        let hasAccess = false;

        switch (to.meta.requiresPermission) {
          case 'clientes':
            hasAccess = canAccessClientes(userPermissions);
            break;
          case 'templates':
            hasAccess = canAccessTemplates(userPermissions);
            break;
          case 'logins':
            hasAccess = canAccessUsuarios(userPermissions);
            break;
          case 'supervisao': {
            if (!store.getters['supervisao/isSupervisaoLoaded']) {
              await store.dispatch('supervisao/fetchSupervisionados');
            }
            const supervisionados = store.getters['supervisao/getSupervisionados'] || [];
            hasAccess = canAccessSupervisao(userPermissions, supervisionados);
            break;
          }
          default:
            hasAccess = true;
        }

        if (!hasAccess) {
          // Redirecionar para home se não tem permissão
          next({ name: 'home' });
          return;
        }
      }

      next();
    }
  } else {
    // Não requer autenticação
    next();
  }
});

// Exportando router
export default router;
